import React from "react";
import { useNavigate } from "react-router-dom";
import "./PrivacyPolicy";

const Disclaimer = () => {
  const navigate = useNavigate();

  return (
    <div className="refund-policy-container">
      <button className="back-button" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <h1>Shipping and Delivery Policy</h1>
      <p>Last updated: April 28, 2025</p>

      <h2>General Information</h2>
      <p>
        Arrow Digital Marketing is a digital services company. We specialize in
        providing services such as website development, e-commerce solutions,
        digital marketing, SEO, and PPC campaigns.
      </p>

      <h2>No Shipping or Delivery Services</h2>
      <p>
        Please note that Arrow Digital Marketing does not sell any physical
        goods or products. As such, we do not offer or facilitate any shipping
        or physical delivery services to customers.
      </p>
      <p>
        All services provided by Arrow Digital Marketing are delivered
        electronically or through digital means, such as email, cloud-based
        platforms, or remote access tools.
      </p>

      <h2>Service Fulfillment</h2>
      <p>
        Our services are typically fulfilled via online communication after
        agreement and payment. Delivery timelines for digital services vary
        depending on the scope of work and will be communicated clearly during
        the project discussion and onboarding process.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions about our Shipping and Delivery Policy, you
        can contact us:
      </p>
      <ul>
        <li>
          By visiting this page on our website:{" "}
          <a
            href="https://arrowdigitalmarketing.com/"
            rel="external nofollow noopener"
            target="_blank"
          >
            https://arrowdigitalmarketing.com/
          </a>
        </li>
      </ul>
      <button className="back-button" onClick={() => navigate(-1)}>
        ← Back
      </button>
    </div>
  );
};

export default Disclaimer;
